import React from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faEye,
  faEyeSlash,
  faChevronUp,
  faChevronDown
} from "@fortawesome/free-solid-svg-icons";

const SectionToggleControls = ({ 
  sectionVisibility, 
  onToggleSection, 
  onToggleAllSections 
}) => {
  return (
    <Card className="shadow-sm report-card mb-3">
      <Card.Header className="bg-light">
        <Row className="align-items-center">
          <Col>
            <h6 className="mb-0">
              <FontAwesomeIcon icon={faEye} className="me-2" />
              Pokaż/Ukryj sekcje raportu
            </h6>
          </Col>
          <Col xs="auto">
            <div className="d-flex gap-2">
              <Button
                variant="outline-success"
                size="sm"
                onClick={() => onToggleAllSections(true)}
                title="Rozwiń wszystkie sekcje"
              >
                <FontAwesomeIcon icon={faEye} className="me-1" />
                Rozwiń wszystkie
              </Button>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => onToggleAllSections(false)}
                title="Zwiń wszystkie sekcje"
              >
                <FontAwesomeIcon icon={faEyeSlash} className="me-1" />
                Zwiń wszystkie
              </Button>
            </div>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="py-2">
        <Row className="g-2">
          <Col md={3}>
            <Button
              variant={sectionVisibility.shopStatus ? "primary" : "outline-secondary"}
              size="sm"
              className="w-100"
              onClick={() => onToggleSection('shopStatus')}
            >
              <FontAwesomeIcon icon={sectionVisibility.shopStatus ? faChevronUp : faChevronDown} className="me-1" />
              Status drogerii
            </Button>
          </Col>
          <Col md={3}>
            <Button
              variant={sectionVisibility.deviceHealth ? "primary" : "outline-secondary"}
              size="sm"
              className="w-100"
              onClick={() => onToggleSection('deviceHealth')}
            >
              <FontAwesomeIcon icon={sectionVisibility.deviceHealth ? faChevronUp : faChevronDown} className="me-1" />
              Status urządzeń
            </Button>
          </Col>
          <Col md={3}>
            <Button
              variant={sectionVisibility.playlistStatus ? "primary" : "outline-secondary"}
              size="sm"
              className="w-100"
              onClick={() => onToggleSection('playlistStatus')}
            >
              <FontAwesomeIcon icon={sectionVisibility.playlistStatus ? faChevronUp : faChevronDown} className="me-1" />
              Status playlist
            </Button>
          </Col>
          <Col md={3}>
            <Button
              variant={sectionVisibility.tagsAnalysis ? "primary" : "outline-secondary"}
              size="sm"
              className="w-100"
              onClick={() => onToggleSection('tagsAnalysis')}
            >
              <FontAwesomeIcon icon={sectionVisibility.tagsAnalysis ? faChevronUp : faChevronDown} className="me-1" />
              Analiza tagów
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default SectionToggleControls;